import { render, staticRenderFns } from "./productIdEdit.vue?vue&type=template&id=7690616e&scoped=true"
import script from "./productIdEdit.vue?vue&type=script&lang=js"
export * from "./productIdEdit.vue?vue&type=script&lang=js"
import style0 from "./productIdEdit.vue?vue&type=style&index=0&id=7690616e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7690616e",
  null
  
)

export default component.exports